const addCfImageParams = (url: string, width: number, fit = 'fill'): string => {
  const urlObj = new URL(url);
  urlObj.searchParams.set('w', width.toString());
  urlObj.searchParams.set('fm', 'webp');
  urlObj.searchParams.set('fit', fit);
  return urlObj.toString();
};

export const getHeroImageSrcSet = (url: string, type: 'bg' | 'block'): string | undefined => {
  // Works only for images from Contentful Images API
  if (!url.includes('images.ctfassets.net')) return undefined;

  const blockWidths = [400, 600, 648, 824, 1300];
  const bgWidths = [400, 800, 1024, 1280, 1600, 2048, 2560];
  let srcSet = '';
  if (type === 'block') {
    srcSet = blockWidths.map((w) => `${addCfImageParams(url, w, 'scale')} ${w}w`).join(', ');
  } else {
    // Background fill image
    srcSet = bgWidths.map((w) => `${addCfImageParams(url, w, 'fill')} ${w}w`).join(', ');
  }
  return srcSet;
};
